import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-authority',
  templateUrl: './access-authority.component.html',
  styleUrls: ['./access-authority.component.scss'],
})
export class AccessAuthorityComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {}

  dataPolicy(){
    this.router.navigate(['/main/data-policy']);
  }

}
